import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const isTestEnv = process.env.NODE_ENV === 'test';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: isTestEnv ? false : 3,
      cacheTime: isTestEnv ? 0 : 30 * 60 * 1000,
    },
    mutations: {
      retry: isTestEnv ? false : 0,
    },
  },
});

export const QueryProvider = ({ children }: { children: React.ReactNode }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
